import React from 'react'
import ServiceTemplate from '../../components/ServiceTemplate'
import { Cloud, Users, Lock, Zap } from 'lucide-react'

const SaaSDevelopment = () => {
  const features = [
    {
      icon: <Cloud className="w-6 h-6" data-component-path="client/src/pages/services/SaaSDevelopment.jsx" data-component-line="7:12" data-component-id="client/src/pages/services/SaaSDevelopment.jsx:7:12" />,
      title: 'Multi-Tenant Architecture',
      description: 'Scalable cloud infrastructure for thousands of users'
    },
    {
      icon: <Users className="w-6 h-6" data-component-path="client/src/pages/services/SaaSDevelopment.jsx" data-component-line="13:12" data-component-id="client/src/pages/services/SaaSDevelopment.jsx:13:12" />,
      title: 'User Management',
      description: 'Advanced role-based access control systems'
    },
    {
      icon: <Lock className="w-6 h-6" data-component-path="client/src/pages/services/SaaSDevelopment.jsx" data-component-line="19:12" data-component-id="client/src/pages/services/SaaSDevelopment.jsx:19:12" />,
      title: 'Enterprise Security',
      description: 'Bank-level encryption and compliance standards'
    },
    {
      icon: <Zap className="w-6 h-6" data-component-path="client/src/pages/services/SaaSDevelopment.jsx" data-component-line="25:12" data-component-id="client/src/pages/services/SaaSDevelopment.jsx:25:12" />,
      title: 'Real-Time Analytics',
      description: 'Comprehensive dashboards and reporting tools'
    },
  ]

  return (
    <ServiceTemplate
      title="SaaS Development"
      subtitle="Build scalable multi-tenant platforms that grow with your business"
      description="We specialize in creating enterprise-grade SaaS platforms with robust multi-tenant architecture, advanced security, and seamless scalability. Our solutions handle thousands of concurrent users while maintaining peak performance and reliability."
      features={features}
      heroImage="https://images.pexels.com/photos/3861969/pexels-photo-3861969.jpeg?auto=compress&cs=tinysrgb&w=1920"
    />
  )
}

export default SaaSDevelopment